import { Link, useLocation } from 'react-router-dom';

export default function BottomNav({ menuOpen, onToggleMenu }) {
  const { pathname } = useLocation();
  const isHome = pathname === '/' || pathname === '';
  const isFlights = pathname === '/flights' || pathname.startsWith('/flight');
  const isServices = pathname === '/services' || pathname.startsWith('/services');
  const menuActive = menuOpen || (!isHome && !isFlights && !isServices);

  return (
    <nav className="bottom-nav" aria-label="Quick navigation">
      <Link
        to="/"
        className={`bottom-nav__item${isHome && !menuOpen ? ' bottom-nav__item--active' : ''}`}
        aria-current={isHome && !menuOpen ? 'page' : undefined}
        onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
      >
        <span className="bottom-nav__icon" aria-hidden="true">
          <svg className="bottom-nav__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <path d="M9 22V12h6v10" />
          </svg>
        </span>
        <span className="bottom-nav__label">Home</span>
      </Link>

      <Link
        to="/flights"
        className={`bottom-nav__item${isFlights && !menuOpen ? ' bottom-nav__item--active' : ''}`}
        aria-current={isFlights && !menuOpen ? 'page' : undefined}
      >
        <span className="bottom-nav__icon" aria-hidden="true">
          <svg className="bottom-nav__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
          </svg>
        </span>
        <span className="bottom-nav__label">Flights</span>
      </Link>

      <Link
        to="/services"
        className={`bottom-nav__item${isServices && !menuOpen ? ' bottom-nav__item--active' : ''}`}
        aria-current={isServices && !menuOpen ? 'page' : undefined}
      >
        <span className="bottom-nav__icon" aria-hidden="true">
          <svg className="bottom-nav__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </span>
        <span className="bottom-nav__label">Services</span>
      </Link>

      <button
        type="button"
        className={`bottom-nav__item bottom-nav__item--action${menuActive ? ' bottom-nav__item--active' : ''}`}
        id="bottomNavMenu"
        aria-label="Open full site menu"
        aria-expanded={menuOpen}
        onClick={onToggleMenu}
      >
        <span className="bottom-nav__icon" aria-hidden="true">
          <svg className="bottom-nav__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </span>
        <span className="bottom-nav__label">Menu</span>
      </button>
    </nav>
  );
}
